import { FC, PropsWithChildren } from 'react';

import { ProjectName } from 'CONFIG_TYPES';

import { BackgroundLogoIcon } from '../BackgroundLogoIcon/BackgroundLogoIcon';
import { WrapperContentCoWork } from '../WrapperContentCoWork/WrapperContentCoWork';
import { WrapperContentGemTeam } from '../WrapperContentGemTeam/WrapperContentGemTeam';

export const WrapperContent: FC<PropsWithChildren> = ({ children }) => {
  const isShowContentCoWork = PROJECT_NAME === ProjectName.Cowork;
  // TODO: провести ревизию WrapperContentCoWork и WrapperContentGemTeam и посмотреть в сторону переиспользования
  // кода из components/layouts/LoginLayout
  return (
    <>
      {isShowContentCoWork ? (
        <WrapperContentCoWork>{children}</WrapperContentCoWork>
      ) : (
        <>
          <BackgroundLogoIcon />
          <WrapperContentGemTeam>{children}</WrapperContentGemTeam>
        </>
      )}
    </>
  );
};
